import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  PortChange,
  PortChangeParams,
  PortChangeApiResponse,
} from "./PortChangeType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

const initialState: PortChange = {
  portChange: null,
  updatedTime: "",
  loading: false,
  error: "",
  change_mobility: "",
  change_port: "",
};

// 非同期関数の作成
export const fetchAsyncPortChange: any = createAsyncThunk<
  PortChangeParams,
  PortChangeApiResponse
>("PortChange/put", async ({ change_mobility, change_port }) => {
  const response = await axiosSettings.put("api-admin/mobility/port", {
    change_mobility,
    change_port,
  });
  return response.data;
});

// Sliceの定義
const PortChangeSlice = createSlice({
  name: "portChange",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncPortChange.fulfilled, (state, action) => {
      if (action.payload.status === "Success") {
        state.portChange = action.payload.data;
        state.updatedTime = GetTime();
        state.error = "";
      } else {
        state.error = action.payload.data;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncPortChange.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncPortChange.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export const portChangeState = (state: RootState) =>
  state.PortChange.portChange;
export const PortInfoStatus = (state: RootState) => state.PortInfo.portStatus;
export const portChangeError = (state: RootState) => state.PortChange.error;
export const portChangeLoading = (state: RootState) => state.PortChange.loading;
export const portChangeUpdatedTime = (state: RootState) =>
  state.PortChange.updatedTime;
export const changeMobility = (state: RootState) =>
  state.PortChange.change_mobility;
export default PortChangeSlice.reducer;
